import { FC } from "react";
import { Namespace, useT } from "@racoon/i18n";
import { SearchableSelect } from "@racoon/ui";

type Props = {
  id: string;
  value: string;
  onChange: (id: string) => void;
  options: { id: string; name: string; secondary?: string }[];
  /** Name of the stored provider while the options load, or when it is not among them. */
  valueLabel?: string;
  loading?: boolean;
  disabled?: boolean;
};

/** "Мусоровывозящая организация" section (Figma 22790:51039). */
export const WasteOperatorSelect: FC<Props> = ({ id, valueLabel, ...props }) => {
  const t = useT();
  return (
    <div className="flex flex-col gap-4">
      <label htmlFor={id} className="text-xs font-bold uppercase text-text-body">
        {t(Namespace.Common, "wasteOperator")}
      </label>
      <SearchableSelect
        id={id}
        size="sm"
        valueLabel={valueLabel}
        searchPlaceholder={t(Namespace.Common, "search")}
        {...props}
      />
    </div>
  );
};
